require('z-shop-js-env');
require('z-shop-css-env/style.css');

exports.classnames = require('classnames');
exports.react = require('react');
exports['react-dom'] = require('react-dom');
exports['z-shop-event-bus'] = require('z-shop-event-bus');
exports.tranzlate = require('tranzlate');
exports[
    'zalando-consent-api'
] = require('@zalando-internal/zalando-consent-api');

if (window.location.search.indexOf('translationDebuggingMode=1') >= 0) {
    exports.tranzlate.passThrough = true;
}

exports['safe-fetch'] = require('./fetch-extension');
